<template>
  <div id="tree" v-loading="webLoading">
    <div class="SubjectTree">
      <ul>
        <template v-for="one in SubjectTreeData">
          <li>
            <i
              :class="one.children?one.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
              @click="showRow(one,$event)"
            ></i>
            <el-tooltip :content="one.name" placement="top">
              <span
                @click="setId(one)"
                class="subname Actionable"
                :style="one.id==nowId?'color:#409EFF':''"
              >{{ one.name |filterText}}</span>
            </el-tooltip>
          </li>
          <ul class="showActive">
            <template v-for="two in one.children">
              <li>
                <i
                  :class="two.children?two.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
                  @click="showRow(two,$event)"
                ></i>
                <el-tooltip :content="two.name" placement="top">
                  <span
                    @click="setId(two)"
                    class="subname Actionable"
                    :style="two.id==nowId?'color:#409EFF':''"
                  >{{ two.name |filterText}}</span>
                </el-tooltip>
              </li>
              <ul class="showActive">
                <template v-for="three in two.children">
                  <li class="SubjectItem">
                    <i
                      :class="three.children?three.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
                      @click="showRow(three,$event)"
                    ></i>
                    <el-tooltip :content="three.name" placement="top">
                      <span
                        @click="setId(three)"
                        class="subname Actionable"
                        :style="three.id==nowId?'color:#409EFF':''"
                      >{{ three.name |filterText}}</span>
                    </el-tooltip>
                  </li>
                  <ul class="showActive">
                    <template v-for="four in three.children">
                      <li class="SubjectItem">
                        <i
                          :class="four.children?four.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
                          @click="showRow(four,$event)"
                        ></i>
                        <el-tooltip :content="four.name" placement="top">
                          <span
                            @click="SubjectTreeClick(four,3)"
                            class="subname Actionable"
                            :style="four.id==nowId?'color:#409EFF':''"
                          >{{ four.name |filterText}}</span>
                        </el-tooltip>
                      </li>
                      <ul class="showActive">
                        <template v-for="five in four.children">
                          <li class="SubjectItem">
                            <i
                              :class="five.children?five.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
                              @click="showRow(five,$event)"
                            ></i>
                            <el-tooltip :content="five.name" placement="top">
                              <span
                                @click="SubjectTreeClick(five,3)"
                                class="subname Actionable"
                                :style="five.id==nowId?'color:#409EFF':''"
                              >{{ five.name |filterText2}}</span>
                            </el-tooltip>
                          </li>
                          <ul class="showActive">
                            <template v-for="six in five.children">
                              <li class="SubjectItem">
                                <i
                                  :class="six.children?six.children.length>0?'iconfont iconicon-test':'iconfont iconjianhao2':'iconfont iconjianhao2'"
                                  @click="showRow(six,$event)"
                                ></i>
                                <el-tooltip :content="six.name" placement="top">
                                  <span
                                    @click="SubjectTreeClick(six,3)"
                                    class="subname Actionable"
                                    :style="six.id==nowId?'color:#409EFF':''"
                                  >{{ six.name |filterText}}</span>
                                </el-tooltip>
                              </li>
                              <ul class="showActive">
                                <template v-for="seven in six.children">
                                  <li class="SubjectItem">
                                    <el-tooltip :content="seven.name" placement="top">
                                      <span
                                        @click="SubjectTreeClick(seven,3)"
                                        class="subname Actionable"
                                        :style="seven.id==nowId?'color:#409EFF':''"
                                      >{{ seven.name |filterText2}}</span>
                                    </el-tooltip>
                                  </li>
                                </template>
                              </ul>
                            </template>
                          </ul>
                        </template>
                      </ul>
                    </template>
                  </ul>
                </template>
              </ul>
            </template>
          </ul>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    showAdd: {
      type: String
    }
  },
  filters: {
    filterText(val) {
      if (val.length > 10) {
        return val.substr(0, 10) + "...";
      } else {
        return val;
      }
    },
    filterText2(val) {
      if (val.length > 7) {
        return val.substr(0, 7) + "...";
      } else {
        return val;
      }
    }
  },
  data() {
    return { nowId: "", SubjectTreeData: [], webLoading: false };
  },
  created() {
    this.getCampusTreeList();
  },
  methods: {
    setId(data) {
      this.nowId = data.id;
      this.$emit("setIds", data);
    },
    //   获取下拉
    getCampusTreeList() {
      this.webLoading = true;

      this.api.campus
        .getCampusTree({parentId:0})
        .then(res => {
          this.webLoading = false;
          this.CampusTreeData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 展开折叠
    showRow(data, e) {
      if (data.children.length > 0) {
        if (
          e.currentTarget.getAttribute("class") === "iconfont iconicon-test"
        ) {
          e.currentTarget.setAttribute("class", "iconfont iconjianhao2");
        } else {
          e.currentTarget.setAttribute("class", "iconfont iconicon-test");
        }
        let _this = e.currentTarget.parentNode.nextSibling.nextSibling;
        let currClass = _this.getAttribute("class");
        currClass
          ? _this.setAttribute("class", "")
          : _this.setAttribute("class", "showActive");
      }
    }
  },
  computed: {}
};
</script>

<style lang="less" rel="stylesheet/less">
#tree {
  .border-none {
    border: 0px !important;
    margin-right: 10px !important;
    color: #4d94ff !important;
  }
  .border-none:last-child {
    margin-right: 0px !important;
  }
  width: 100%;
  .SubjectTree {
    padding: 5px;
    margin-top: -10px;
  }
  .SubjectTree ul {
    list-style: none;
    padding: 0px;
  }
  .SubjectTree ul ul {
    margin-left: 13px;
    border-left: 1px dotted #999999;
  }
  .SubjectTree ul li {
    padding: 5px 0;
    padding-left: 8px;
    cursor: pointer;
  }
  .SubjectTree ul li:hover {
    background: #f4f4f4;
  }
  .iconfont {
    font-size: 12px;
    color: #666666;
    border: 1px solid #dddddd;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    text-align: center;
    display: inline-block;
    line-height: 12px;
  }
  .SubjectTree .SubjectItem {
    padding-left: 15px;
    position: relative;
  }
  .SubjectTree .SubjectItem:before {
    content: "";
    border-top: 1px dotted #999999;
    width: 10px;
    position: absolute;
    top: 14px;
    left: 1px;
  }
  .SubjectTree span.action {
    float: right;
    padding-right: 8px;
  }
  .SubjectItemTree-title {
    padding: 0 3px 2px 8px;
    background-color: #f4f7fc;
    font-size: 12px;
    color: #424a53;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    border-bottom: #e4e9ed solid 1px;
  }
  .SubjectItemTree {
    border: #e4e9ed solid 1px;
    border-radius: 5px;
    width: 100%;
  }
  .SubjectItemTree .SubjectItemBox {
    float: right;
    padding-right: 30px;
  }
  .SubjectItemTree > ul {
    margin: 8px 0 20px 0;
  }
  .SubjectItemTree li {
    height: 22px;
    line-height: 22px;
    padding: 5px 0;
    margin: 0 8px;
    border-bottom: #e4e9ed solid 1px;
    padding-left: 6px;
  }

  .SubjectItemTree ul {
    list-style: none;
    padding-left: 0;
  }
  .SubjectItemTree ul ul li {
    padding-left: 38px;
    clear: both;
  }
  .Actionable:hover {
    color: #45a2ff;
  }
  i {
    cursor: pointer;
  }
  .subname {
    cursor: pointer;
  }
  .showActive {
    display: none;
  }
  .el-aside {
    width: 220px;
    margin-right: 15px;
  }
  .el-main {
    padding: 0;
  }
  .aside-box {
    border: #e4e9ed solid 1px;
    border-radius: 5px;
  }
  .aside-title {
    padding: 8px;
    background-color: #f4f7fc;
    font-size: 13px;
    color: #424a53;
    font-weight: bold;
  }
  .from {
    margin-right: 30px;
  }
  .selectaaa {
    font-size: 13px;
    color: #333;
    padding: 20px 0px;
  }
  .border-none {
    border: 0px !important;
    margin-right: 10px !important;
    color: #45a2ff !important;
  }
  .border-none:last-child {
    margin-right: 0px !important;
  }
  .my-star-require .el-input-group__prepend {
    width: 55px;
    padding: 0px;
    text-align: right;
    position: absolute;
    line-height: 35px;
    border: 0px;
  }
  .my-star-require .el-input.is-disabled .el-input-group__prepend {
    background: none;
  }
  .my-star-require .el-input-group--prepend .el-input__inner {
    border-radius: 4px;
    padding-left: 55px;
  }
  #course .el-form-item__content {
    line-height: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classroom/tree.vue